import React from 'react';

export const LoadingDots: React.FC = () => {
    return(
        <div className="loading-dots">
            <div className="loading-dot"></div>
            <div className="loading-dot"></div>
            <div className="loading-dot"></div>
        </div>
    )
};
export function getFullYear() {
    const currentYear = new Date().getFullYear();
    return currentYear;
  }